'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var Typography_web = require('../../../atoms/Typography/Typography.web.cjs');
var Price_web_styles = require('../Price.web.styles.cjs');

/**
 * The wholesale variant of the Price component.
 */ const WholesalePrice = ({ formattedSellPrice, msrp, isCAD })=>{
    return /*#__PURE__*/ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ jsxRuntime.jsxs("span", {
                css: Price_web_styles.sellPrice,
                children: [
                    formattedSellPrice,
                    " ",
                    isCAD ? "CAD" : ""
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                as: "span",
                isMarginless: true,
                children: "Wholesale"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("span", {
                css: Price_web_styles.wholesaleDivider,
                children: "|"
            }),
            /*#__PURE__*/ jsxRuntime.jsxs(Typography_web.Typography, {
                as: "span",
                isMarginless: true,
                children: [
                    "MSRP ",
                    msrp.toFixed(2)
                ]
            })
        ]
    });
};

exports.WholesalePrice = WholesalePrice;
//# sourceMappingURL=WholesalePrice.web.cjs.map
